import React from 'react'
import className from 'classnames'

import SortableListLabel from './SortableListLabel'
import SortableListMenu from './SortableListMenu'
import PropTypes from 'prop-types'
import './SortableList.scss'

/**
 * Possible sorting options that can be passed in as an array
 *
 * recentlyLogged, recentlyViewed, recentlyAdded, relevance, rank, date, az
 */

class SortableList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false
    }

    this.optionTitles = {
      recentlyLogged: 'Recently Loggeed',
      recentlyViewed: 'Recently Viewed',
      recentlyAdded: 'Recently Added',
      relevance: 'Most Relevant',
      rank: 'Most Popular',
      date: 'Newest',
      az: 'az',
      oldest: 'Oldest',
      title: 'Class Name A-Z',
      series: 'Series Name A-Z',
      plan: 'Series Name A-Z',
      style: 'Style A-Z',
      instructor: 'Instructor Name  A-Z',
      durationShortToLong: 'Duration Short-Long',
      durationLongToShort: 'Duration Long-Short',
      7: 'Last 7 Days',
      30: 'Last 30 Days',
      90: 'Last 90 Days',
      all: 'All Time'
    }
  }

  setOrder(order) {
    this.setState({ menuOpen: false })
    this.props.onSort(order)
  }

  toggleMenu() {
    this.setState((prevState) => {
      return {
        menuOpen: !prevState.menuOpen
      }
    })
  }

  render() {
    let listClass = className('SortableList', {
      'SortableList--open': this.state.menuOpen,
      'SortableList--left': this.props.alignLeftXs
    })

    return (
      <div className={listClass}>
        <SortableListLabel
          onClick={this.toggleMenu.bind(this)}
          menuOpen={this.state.menuOpen}
          currentOrder={this.props.order}
          optionTitles={this.optionTitles}
          isMobile={this.props.isMobile}
        />
        <SortableListMenu
          currOrder={this.props.order}
          sortableFields={this.props.sortableFields}
          setOrder={this.setOrder.bind(this)}
          optionTitles={this.optionTitles}
          sortLocation={this.props.sortLocation}
        />
      </div>
    )
  }
}

SortableList.propTypes = {
  order: PropTypes.string,
  onSort: PropTypes.func,
  sortableFields: PropTypes.array,
  alignLeftXs: PropTypes.bool,
  sortLocation: PropTypes.string,
  isMobile: PropTypes.bool
}

export default SortableList
